import Vue from "vue";
import Config from "../configuration";

export default {
    namespaced: true,
    mutations: {

    },
    getters: {

    },
    actions: {
        getTransfersReport (context, payload)
        {
            let self = this;

            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'transfers/' , {ClaimantId: self.state.userInfo.SelectedClaimant.ClaimantId, Current :payload.page, RowCount: payload.rowsPerPage, Sort: payload.sort, Selection: payload.selection, From: payload.from, To: payload.to, Search: payload.search}, {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },

    }
}
